import { createContext, useContext } from "react";

const FrameContext = createContext(null);

export default FrameContext;

export const useFrame = () => useContext(FrameContext);

export function withFrame(Component) {
  return (props) => {
    return (
      <FrameContext.Consumer>
        {(frame) => <Component frame={frame} {...props} />}
      </FrameContext.Consumer>
    );
  };
}
